import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    button: {
        marginTop: theme.spacing(2),
    },
}));
